export default __webpack_public_path__ + "img/list6.a8afcf4d.jpeg";